/* Averso — garde des lignes à prix cassé du panier (sa demande du 18/10/2026, même règle que l'upsell −65 % de Vasylia) :
   - upsell « Un parapluie en plus à −50 % » (produit parapluie-50) : seulement avec au moins 1 parapluie principal
     (produit parapluie), et 1 au plus (la carte du tiroir ne le propose qu'une fois) ;
   - cadeau « 3 Étuis … (OFFERTS) » (produit etuis-offerts, 0 €, « pareil pour les cadeaux ») : seulement avec au moins
     3 parapluies (offre 2 achetés = 1 offert, data-quantity="3" du bloc quantity-gifts de la fiche), et 1 au plus ;
   - cadeau « Étui … (OFFERT) » (produit etui-offert, 0 €, offre 1 acheté = 1 offert, 25/10/2026) : seulement avec
     EXACTEMENT 2 parapluies (maxP), et 1 au plus ;
   - étui à 8,99 € (produit etui, « il manque l'anti-triche pour l'étui ») : seulement avec au moins 1 parapluie,
     et pas plus d'étuis que de parapluies (la carte du tiroir ne s'affiche plus sans parapluie).
   Une ligne qui ne respecte plus sa règle est retirée (ou ramenée à 1) par /cart/update.js :
   - à chaque modification du panier (/cart/change, /cart/update, /cart/clear) et à chaque lecture (/cart.js) :
     la réponse est corrigée AVANT que le thème l'affiche ;
   - après un ajout (/cart/add) ou un appel XHR : vérification juste après ;
   - au chargement de la page (et au retour arrière) ;
   - avant le paiement (bouton du tiroir et bouton de la page panier). */
(function () {
  if (window.__aversoGarde50) return;
  window.__aversoGarde50 = true;

  var MAIN = 'parapluie';
  var REGLES = { 'parapluie-50': { min: 1, max: 1 }, 'etuis-offerts': { min: 3, max: 1 }, 'etui-offert': { min: 2, maxP: 2, max: 1 }, 'etui': { min: 1, max: 'parapluies' } };
  var F = window.fetch.bind(window);
  var MUT = /\/cart\/(change|update|clear)(\.js|\.json)?(\?|$)/;
  var ADD = /\/cart\/add(\.js|\.json)?(\?|$)/;
  var LIRE = /\/cart(\.js|\.json)?(\?|$)/;
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function racine() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function urlDe(x) { return String((x && x.url) || x || '').split('#')[0]; }
  function pageEstPanier() { return /\/cart\/?$/.test(location.pathname); }

  // lignes à corriger : {clé: nouvelle quantité}, ou null si le panier est conforme
  function aCorriger(cart) {
    if (!cart || !cart.items) return null;
    var nMain = 0, reste = {}, maj = {}, n = 0;
    cart.items.forEach(function (it) { if (it.handle === MAIN) nMain += it.quantity; });
    Object.keys(REGLES).forEach(function (h) { var r = REGLES[h]; reste[h] = nMain >= r.min && !(r.maxP && nMain > r.maxP) ? (r.max === 'parapluies' ? nMain : r.max) : 0; });
    cart.items.forEach(function (it) {
      if (!REGLES[it.handle]) return;
      var q = Math.min(it.quantity, reste[it.handle]);
      reste[it.handle] -= q;
      if (q !== it.quantity) { maj[it.key] = q; n++; }
    });
    return n ? maj : null;
  }

  function maj(updates, sections, sectionsUrl, signal) {
    var body = { updates: updates };
    if (sections) { body.sections = sections; body.sections_url = sectionsUrl || location.pathname; }
    var opt = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) };
    if (signal) opt.signal = signal;
    return F(racine() + 'cart/update.js', opt);
  }

  // sections demandées par la requête d'origine (JSON, formulaire ou texte url-encodé)
  function sectionsDe(init) {
    var b = init && init.body, out = {};
    try {
      if (typeof b === 'string') {
        try { var j = JSON.parse(b); out.s = j.sections; out.u = j.sections_url; }
        catch (e) { var p = new URLSearchParams(b); out.s = p.get('sections'); out.u = p.get('sections_url'); }
      } else if (b && typeof b.get === 'function') { out.s = b.get('sections'); out.u = b.get('sections_url'); }
    } catch (e) {}
    return out;
  }

  // tiroir et pastille du panier redessinés depuis un panier corrigé (la page panier, elle, est rechargée)
  function afficher(c) {
    if (pageEstPanier()) { location.reload(); return; }
    var items = document.querySelector('cart-drawer-items'), drawer = document.querySelector('cart-drawer');
    try {
      if (items && items.renderSectionsFromCartData && c.sections) items.renderSectionsFromCartData(c);
      if (drawer) drawer.classList.toggle('is-empty', c.item_count === 0);
      if (typeof syncCartDrawerVisibleEmptyState === 'function') syncCartDrawerVisibleEmptyState(drawer);
    } catch (e) {}
  }

  var enCours = null;
  function verifier(rendu) {
    if (enCours) return enCours;
    enCours = F(racine() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var m = aCorriger(cart);
        if (!m) return { cart: cart, corrige: false };
        return maj(m, SECTIONS, location.pathname).then(function (r) { return r.json(); }).then(function (c) {
          if (rendu) afficher(c);
          return { cart: c, corrige: true };
        });
      })
      .finally(function () { enCours = null; });
    return enCours;
  }

  // vérification différée, une fois que plus aucun ajout/modification du panier n'est en cours (ex. offre 2+1 puis son cadeau)
  var minuterie = null, actives = 0;
  function bientot() {
    clearTimeout(minuterie);
    minuterie = setTimeout(function () { if (actives) return bientot(); verifier(true).catch(function () {}); }, 600);
  }

  // fetch : réponses du panier corrigées avant d'arriver au thème
  window.fetch = function (input, init) {
    var url = urlDe(input), p = F.apply(window, arguments);
    var methode = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (ADD.test(url) || MUT.test(url)) {
      actives++;
      p.then(function () { actives--; }, function () { actives--; });
    }
    if (ADD.test(url)) { p.then(function (r) { if (r.ok) bientot(); }, function () {}); return p; }
    if (!(MUT.test(url) || (methode === 'GET' && LIRE.test(url)))) return p;
    return p.then(function (res) {
      if (!res.ok) return res;
      return res.clone().text().then(function (t) {
        var cart; try { cart = JSON.parse(t); } catch (e) { return res; }
        var m = aCorriger(cart);
        if (!m) return res;
        var s = sectionsDe(init);
        return maj(m, s.s || (cart.sections ? Object.keys(cart.sections) : null), s.u, init && init.signal)
          .then(function (r2) { return r2.ok ? r2 : res; }, function (e) { if (e && e.name === 'AbortError') throw e; return res; });
      }, function () { return res; });
    });
  };

  // XHR (applis tierces) : vérification juste après
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__avPanier = ADD.test(urlDe(u)) || MUT.test(urlDe(u)); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () { if (this.__avPanier) this.addEventListener('loadend', bientot); return xs.apply(this, arguments); };

  // bouton Paiement du tiroir (thème EXA : checkoutLoad → handleHiddenCartUpsellsCheckout → /checkout)
  var avant = window.handleHiddenCartUpsellsCheckout;
  if (typeof avant === 'function') {
    window.handleHiddenCartUpsellsCheckout = function (e, btn) {
      if (e && e.preventDefault) e.preventDefault();
      if (btn) btn.disabled = true;
      verifier(false).then(function (r) {
        if (!r.cart.item_count) { afficher(r.cart); if (btn) { btn.disabled = false; btn.classList.remove('loading'); } return; }
        if (r.corrige) afficher(r.cart);
        avant(null, btn);
      }, function () { avant(null, btn); });
      return true;
    };
  }

  // bouton Paiement de la page panier (formulaire /cart + checkout)
  var passe = false;
  document.addEventListener('submit', function (e) {
    var f = e.target, s = e.submitter;
    if (passe || !f || !/\/cart\/?(\?|$)/.test(f.getAttribute('action') || '')) return;
    if (!((s && s.name === 'checkout') || f.querySelector('input[name="checkout"]'))) return;
    e.preventDefault();
    var suite = function () {
      passe = true;
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = '1'; f.appendChild(i);
      HTMLFormElement.prototype.submit.call(f);
    };
    verifier(false).then(function (r) {
      if (!r.cart.item_count) { location.reload(); return; }
      if (r.corrige) { location.href = racine() + 'checkout'; return; }
      suite();
    }, suite);
  }, true);

  // au chargement et au retour arrière
  verifier(true).catch(function () {});
  window.addEventListener('pageshow', function (e) { if (e.persisted) verifier(true).catch(function () {}); });
})();
